import React from 'react'

const Admin = () => {
    return (
        <div className="container-xxl text-white">
            Admin
        </div>
    )
}

export default Admin